import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Link = (props) => {
  const classes = classnames(
    'ds-link',
    {
      'ds-link-solo': props.isSoloLink,
    },
  );
  return (
    <a
      target={props.shouldOpenInSameTab ? '' : '_blank'}
      rel="noreferrer noopener"
      href={props.href}
      className={classes}
    >
      {props.children}
      {props.isSoloLink && (
        <React.Fragment>&nbsp;&rsaquo;</React.Fragment>
      )}
    </a>
  );
};

Link.defaultProps = {
  isSoloLink: false,
  shouldOpenInSameTab: false,
};

Link.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  isSoloLink: PropTypes.bool,
  shouldOpenInSameTab: PropTypes.bool,
};

export default Link;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Link/index.jsx